import { array2Object } from '@bigo/helpers';

import { MenuId } from './menu';

export type PermissionItem = {
  /** ID */
  id: string;
  /** 名称 */
  name: string;
  parentId: string;
};

export enum PermissionId {
  budgetTotalApplyTab = 'budgetTotalApplyTab',
  budgetAmountSubCreate = 'budgetAmountSubCreate',
  budgetAmountSubEdit = 'budgetAmountSubEdit',
  budgetApproval = 'budgetApproval',
  budgetTotalApplyLock = 'budgetTotalApplyLock',
  budgetTotalApplyStart = 'budgetTotalApplyStart',
  budgetAmountParentCreate = 'budgetAmountParentCreate',
  budgetAmountParentEdit = 'budgetAmountParentEdit',
  budgetAmountParentApply = 'budgetAmountParentApply',
}

const permission: PermissionItem[] = [
  {
    id: PermissionId.budgetTotalApplyTab,
    name: '预算总额申请管理-子级预算总额申请',
    parentId: MenuId.budgetTotalApply,
  },
  {
    id: PermissionId.budgetAmountSubCreate,
    name: '预算总额申请管理-子级预算总额录入',
    parentId: MenuId.budgetTotalApply,
  },
  {
    id: PermissionId.budgetAmountSubEdit,
    name: '预算总额申请管理-子级预算总额编辑',
    parentId: MenuId.budgetTotalApply,
  },
  {
    id: PermissionId.budgetApproval,
    name: '预算总额申请管理-子级预算总额审批配置',
    parentId: MenuId.budgetTotalApply,
  },
  {
    id: PermissionId.budgetAmountParentCreate,
    name: '预算总额申请管理-父级预算总额录入',
    parentId: MenuId.budgetTotalApply,
  },
  {
    id: PermissionId.budgetAmountParentEdit,
    name: '预算总额申请管理-父级预算总额变更',
    parentId: MenuId.budgetTotalApply,
  },
  {
    id: PermissionId.budgetAmountParentApply,
    name: '预算总额申请管理-父级预算总额审批',
    parentId: MenuId.budgetTotalApply,
  },
  {
    id: PermissionId.budgetTotalApplyLock,
    name: '预算总额申请管理-锁定/解锁操作',
    parentId: MenuId.budgetTotalApply,
  },
  {
    id: PermissionId.budgetTotalApplyStart,
    name: '预算总额申请流程发起',
    parentId: '',
  },
];

export const permissionMap = array2Object(permission, 'id');

export const getPermissionName = (id: string) => permissionMap[id]?.name;

export default permission;
